/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import Service, { service } from '@ember/service';
import { isArray } from '@ember/array';
import moment from 'moment';
import { alias } from '@ember/object/computed';

export default class AttendanceMessagesService extends Service {
  // Services
  @service
  session;

  @service
  store;

  @alias('session.school.absenceReportingAvailable')
  absenceReportingAvailable;

  queryDay(personIds, date) {
    return this._getQuery(personIds, moment(date), moment(date)); // Cloning to ensure they're treated separately
  }

  queryMonth(personIds, date) {
    // startDate is the first day of this month
    let startDate = moment(date).date(1);
    // endDate is the last day of this month
    let endDate = moment(date).date(startDate.daysInMonth());

    return this._getQuery(personIds, startDate, endDate);
  }

  queryRange(personIds, start, end) {
    return this._getQuery(personIds, moment(start), moment(end));
  }

  _getQuery(personIds, startDateObj, endDateObj) {
    if (!this.absenceReportingAvailable) {
      return Promise.resolve([]);
    }

    if (!isArray(personIds)) {
      personIds = [personIds];
    }
    // startTime is 3pm on the day before startDate
    let startTime = startDateObj.startOf('day').subtract(9, 'hours').unix();
    // endTime is 3pm on the day of EndDate
    let endTime = endDateObj.endOf('day').subtract(9, 'hours').unix();

    return this.store.query('posts/attendancenote', {
      personIds: JSON.stringify(personIds),
      startTime,
      endTime,
    });
  }
}
